import {DateTime} from 'luxon';
import {TimezoneObject} from 'common/src/modules/timezones/timezones.types';
import getTimeZoneStringForDateTime from './getTimezoneStringForDateTime';

/**
 * Force a specific timezone on the DateTime without changing the hour.
 *
 * @param {DateTime} dateTime - The DateTime object to be modified.
 * @param {number | TimezoneObject} zone - The timezone to force on the DateTime object.
 *
 * @returns {DateTime} - Equivalent DateTime object with the same timestamp.
 *
 * example: input =  (11:30 UTC+5) -> output = (11:30 UTC+5)
 * example: input =  (11:30 UTC+5, {zone: 0}) -> output = (11:30 UTC)
 * example: input =  (11:30 UTC+5, {zone: 2}) -> output = (11:30 UTC+2)
 */
function forceTimeZone(dateTime: DateTime, zone: number | TimezoneObject) {
  return DateTime.fromObject(
    {
      ...dateTime.toObject(),
    },
    {
      zone: getTimeZoneStringForDateTime(zone),
    },
  );
}

export default forceTimeZone;
